//utils/setFavicon.js

export function setFavicon(appLogo) {
  if (!appLogo) return;

  const favicon = document.getElementById("dynamic-favicon");
  if (!favicon) return;

  const faviconUrl = appLogo.startsWith("http")
    ? appLogo
    : `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${appLogo}`;

//cache busting so browser refreshes icon
  favicon.href = faviconUrl + "?v=" + Date.now();
  favicon.type = "image/png";
}
